import { CellProps } from '../../../types';
import { Badge, Tooltip, Box, HStack } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from "react-i18next";

const NewMessage = ({ messages }: { messages: number }) => {
    const { t } = useTranslation('common');
  return (
    <Tooltip hasArrow placement="top" label={t('common:unreadMessage', { messages, s: messages > 1 ? 's' : '' })}>
      <Badge variant="indicator" colorScheme="pink">
        <FontAwesomeIcon className="indicator-icon" icon={regular('envelope')} />
        <Box as="span" className="indicator-number">
          {messages}
        </Box>
      </Badge>
    </Tooltip>
  );
};

const View = ({ userNames }: { userNames: string[] }) => {
    const { t } = useTranslation('common');
  return (
    <Tooltip hasArrow placement="top" label={t('common:viewedBy', { join: userNames.join(',') })}>
      <Badge variant="indicator" colorScheme="violet">
        <FontAwesomeIcon className="indicator-icon" icon={regular('eyes')} />
      </Badge>
    </Tooltip>
  );
};

const NewDocuments = () => {
    const { t } = useTranslation('common');
  return (
    <Tooltip hasArrow placement="top" label={t('common:newDocuments')}>
      <Badge variant="indicator" colorScheme="indigo">
        <FontAwesomeIcon className="indicator-icon" icon={regular('file')} />
      </Badge>
    </Tooltip>
  );
};

export const Icons = ({ cellProps }: { cellProps: CellProps }) => {
  const isShowMessageIcon = cellProps.row.unreadMessagesCount && cellProps.row.unreadMessagesCount > 0;
  const isShowViewIcon = cellProps.row.isOpened ?? false;
  const isShowNewDocumentsIconIcon = cellProps.row.isNewDocuments === 'Yes';

  return (
    <HStack spacing="1">
      {isShowMessageIcon ? <NewMessage messages={cellProps.row.unreadMessagesCount} /> : ''}
      {isShowViewIcon ? <View userNames={cellProps.row.openedBy ?? []} /> : ''}
      {isShowNewDocumentsIconIcon ? <NewDocuments /> : ''}
    </HStack>
  );
};
